export default [
    {
        path: 'grupo',
        component: () => import(
            /* webpackChunkName: 'cadastro-grupo' */
            '@/views/cadastro/grupo/Index'
        ),
        redirect: 'grupo/index',
        children: [
            {
                name: 'cadastro-grupo-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-grupo' */
                    '@/views/cadastro/grupo/List.vue'
                ),
            },
            {
                name: 'cadastro-grupo-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-grupo' */
                    '@/views/cadastro/grupo/Form.vue'
                ),
            },
            {
                name: 'cadastro-grupo-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-grupo' */
                    '@/views/cadastro/grupo/Form.vue'
                ),
            },
        ],
    },
]